module.exports = __webpack_public_path__ + "img/news-3.205dd761.png";